const DISPLAY_OVERRIDES: Record<string, string> = {
  llm_reviewer: "LLM Reviewer",
  market_data_agent: "Market Data Agent",
}

/**
 * Turn backend agent keys (snake_case) into readable labels without underscores.
 */
export function formatAgentName(raw: string | undefined | null): string {
  if (!raw) return "Agent"
  const key = raw.trim().toLowerCase().replace(/-/g, "_")
  if (DISPLAY_OVERRIDES[key]) return DISPLAY_OVERRIDES[key]
  return key
    .split("_")
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(" ")
}
